import {Component, effect, inject} from '@angular/core';
import {GatewaySvgComponent} from "src/app/presentation/common/icons/gateway-svg/gateway-svg.component";
import {LoRaGateway} from "src/app/infrastructure/moovement-api/models/asset";
import {Router} from '@angular/router';
import {GatewayStore} from 'src/app/domain/devices/gateway/gateway.store';
import {GatewayStatusStore} from 'src/app/domain/devices/gateway/gateway-status.store';

@Component({
  selector: 'app-gateways-button',
  imports: [
    GatewaySvgComponent,
  ],
  templateUrl: './gateways-button.component.html',
  styleUrl: './gateways-button.component.css'
})
export class GatewaysButtonComponent {

  protected onlineStateGateways: Array<LoRaGateway> = []
  protected offlineStateGateways: Array<LoRaGateway> = []
  protected unknownStateGateways: Array<LoRaGateway> = []

  private gatewayStore = inject(GatewayStore);
  private gatewayStatusStore = inject(GatewayStatusStore);
  private router = inject(Router);

  constructor() {
    effect(() => {
      const gateways = this.gatewayStore.entities();
      if (!gateways) return;

      const gatewayStatuses = this.gatewayStatusStore.entityMap();
      if (!gatewayStatuses) return;

      this.onlineStateGateways = gateways.filter(gateway => {
        const status = gatewayStatuses[(gateway.id)];
        if (!status) return false;
        return status.normalisedValue === 'ONLINE';
      });

      this.offlineStateGateways = gateways.filter(gateway => {
        const status = gatewayStatuses[(gateway.id)];
        if (!status) return false;
        return status.normalisedValue === 'OFFLINE';
      });

      this.unknownStateGateways = gateways.filter(gateway => {
        const status = gatewayStatuses[(gateway.id)];
        if (!status) return true;
        return status.normalisedValue === undefined || status.normalisedValue === 'UNKNOWN';;
      });
    });
  }

  open(url: string): void {
    this.router.navigate([url]);
  }
}
